import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BodyCopy } from "../../components/BodyCopy";
import {
  AuraLayout,
  Button,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { UserCheckIcon } from "lola-framework-ui-test/src/icons";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { LOLA_ROUTES } from "../../constants";
import { useStore } from "../../store/globalState";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";

/**
 * Gallery stub for embedded Kentucky CIP. The live flow mounts KentuckyKYC here;
 * the SDK is not loaded in the screenbook.
 */
export const CipPage = memo(() => {
  const { t } = useTranslation("lola");
  const { theme } = useStore();
  const navigate = useNavigate();
  const colorConfig = theme.whiteView;
  const { backgroundBtn, textColorBtn, title, bodyCopy, dropzoneColors, backgroundIcon } =
    colorConfig;

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundIcon}
          >
            <UserCheckIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("cip.title")}
              highlightColor={title}
              secudnary=""
              secudnaryColor={title}
            />
            <BodyCopy textColor={bodyCopy}>{t("cip.body")}</BodyCopy>
          </section>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          <Button
            size="large"
            background={backgroundBtn}
            color={textColorBtn}
            onClick={() => navigate(LOLA_ROUTES.TRANSFERRING)}
          >
            {t("cip.cta")}
          </Button>
        </section>
      </Layout.Footer>
    </AuraLayout>
  );
});
